import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {Observable} from 'rxjs';

export interface ItemValueOverride {
    location: string;
    variationTag: string;
    variationLabel: string;
    attribute: string;
    value: string;
    baseValue: string;
    base: boolean;
}

export interface GroupedOverrides {
    variationTag: string;
    variationLabel: string;
    overrides: ItemValueOverride[];
}

@Component({
    selector: 'emm-value-overrides-card',
    templateUrl: './value-overrides-card.component.html',
    styleUrls: ['./value-overrides-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ValueOverridesCardComponent implements OnChanges {
    @Input() overrides: ItemValueOverride[] = [];
    @Input() isLoading$: Observable<boolean>;

    readonly displayedColumns: string[] = ['location', 'attribute', 'value'];
    groupedOverrides: GroupedOverrides[] = [];

    ngOnChanges(): void {
        this.groupedOverrides = [...this.groupByVariation(this.overrides)];
    }

    private groupByVariation(overrides: ItemValueOverride[]): GroupedOverrides[] {
        const grouped = overrides.reduce((acc, override) => {
            if (!acc[override.variationTag]) {
                acc[override.variationTag] = [];
            }
            acc[override.variationTag].push(override);
            return acc;
        }, {} as Record<string, ItemValueOverride[]>);

        return Object.entries(grouped).map(([variation, overrides]) => ({
            variationTag: variation,
            variationLabel: overrides[0]?.variationLabel ?? '',
            overrides
        }));
    }
}
